/* Decora — frete por CEP (página de produto e carrinho).
   Contrato: window.DecoraFrete.cotar(cep, [{sku, quantity}]) -> Promise<[{nome, valor, prazo_dias}] | {erro}>
   Linha Suprema (SKU LQ- janela, PC- porta): regras da Yampi de 28/10/2026, aplicadas aqui.
   Produtos antigos: resposta da edge calcular-frete sem mudança. */
(function () {
  if (window.DecoraFrete) return;

  var EDGE = 'https://abaswhkkrzxmcstdnnbd.supabase.co/functions/v1/calcular-frete';
  var CHAVE = 'decora_cep';
  var GRANDE_SP = [[1000000, 9999999]];
  var INTERIOR = [[13000000, 13149999], [13170000, 13189999], [13200000, 13259999], [13270000, 13299999],
    [13330000, 13349999], [12200000, 12249999], [12280000, 12349999]];
  var SEM_JADLOG = ['200x100', '180x120', '200x120']; // largura x altura
  // Despacho somado ao prazo da Jadlog (Léo, 28/10/2026). A edge já devolve Jadlog + 6 (MARKUP_DAYS da v37).
  var DESPACHO_EDGE = 6;
  var DESPACHO_NOVA = [7, 7];   // Linha Suprema: até 7 dias úteis
  var DESPACHO_ANTIGA = [2, 4]; // linha antiga: calcula com 4 e informa de 2 a 4

  var MSG = {
    cep: 'CEP inválido. Confira os 8 dígitos.',
    porta: 'Por enquanto, as portas são entregues só na Grande São Paulo (CEP 01000-000 a 09999-999).',
    grande: 'As medidas 200 × 100, 180 × 120 e 200 × 120 são entregues só na Grande São Paulo e no interior próximo (Campinas, Jundiaí e São José dos Campos).',
    nada: 'Não encontramos frete para este CEP. Fale com a gente no WhatsApp.',
    rede: 'Não foi possível calcular agora. Tente de novo em instantes.'
  };

  var cache = {};

  function limpa(cep) { return String(cep || '').replace(/\D/g, '').slice(0, 8); }
  function naFaixa(n, faixas) { return faixas.some(function (f) { return n >= f[0] && n <= f[1]; }); }
  function medida(sku) { var m = String(sku).match(/-(\d+)x(\d+)/i); return m ? m[1] + 'x' + m[2] : ''; }
  function ehJanelaNova(sku) { return /^LQ-/i.test(sku); }
  function ehPorta(sku) { return /^PC-/i.test(sku); }
  // A edge acha peso e medida pelo SKU base; com sufixo de vidro ou fechamento (-FU, -MB, -2FECH) ela cota errado.
  function skuBase(sku) { return ehJanelaNova(sku) ? sku.replace(/^(.*?-\d+x\d+).*$/i, '$1') : sku; }

  function lerCep() { try { return limpa(localStorage.getItem(CHAVE)); } catch (e) { return ''; } }
  function salvarCep(cep) { cep = limpa(cep); if (cep.length !== 8) return; try { localStorage.setItem(CHAVE, cep); } catch (e) {} }

  function edge(cep, itens) {
    var ctl = window.AbortController ? new AbortController() : null;
    var t = ctl && setTimeout(function () { ctl.abort(); }, 25000);
    return fetch(EDGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cep: cep, items: itens.map(function (i) { return { sku: skuBase(i.sku), quantity: i.quantity }; }) }),
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (t) clearTimeout(t);
      if (!d || !Array.isArray(d.quotes)) throw new Error((d && d.error) || 'sem quotes');
      return d.quotes;
    });
  }

  function ehJadlog(q) { return /jadlog/i.test(q.company || q.name || ''); }
  function opcao(q, despacho) {
    var o = { id: q.service_id, nome: q.name, valor: Number(q.price) || 0, prazo_dias: Number(q.days) || 0 };
    if (despacho && ehJadlog(q)) {
      var base = Math.max(1, o.prazo_dias - DESPACHO_EDGE);
      o.prazo_dias = base + despacho[1];
      if (despacho[0] !== despacho[1]) o.prazo_min_dias = base + despacho[0];
      o.obs = 'Despacho em ' + (despacho[0] === despacho[1] ? 'até ' + despacho[1] : despacho[0] + ' a ' + despacho[1]) +
        ' dias úteis, mais o prazo da transportadora.';
    }
    return o;
  }

  function cotar(cep, itens) {
    cep = limpa(cep);
    itens = (itens || []).filter(function (i) { return i && i.sku && (i.quantity || 0) > 0; })
      .map(function (i) { return { sku: String(i.sku).trim(), quantity: parseInt(i.quantity, 10) || 1 }; });
    if (cep.length !== 8) return Promise.resolve({ erro: MSG.cep });
    if (!itens.length) return Promise.resolve({ erro: 'Escolha o produto para calcular o frete.' });

    var chave = cep + '|' + itens.map(function (i) { return i.sku + ':' + i.quantity; }).sort().join(',');
    if (cache[chave]) return cache[chave];

    var n = parseInt(cep, 10);
    var nova = itens.some(function (i) { return ehJanelaNova(i.sku) || ehPorta(i.sku); });
    var porta = itens.some(function (i) { return ehPorta(i.sku); });
    var grande = itens.some(function (i) { return ehJanelaNova(i.sku) && SEM_JADLOG.indexOf(medida(i.sku)) > -1; });
    var p;

    if (!nova) {
      // Produtos antigos: a edge decide, como antes.
      p = edge(cep, itens).then(function (qs) {
        return qs.length ? qs.map(function (q) { return opcao(q, DESPACHO_ANTIGA); }) : { erro: MSG.nada };
      });
    } else if (naFaixa(n, GRANDE_SP)) {
      // Yampi: frete do serviço + 2 dias de postagem dos SKUs novos (vale o maior prazo do carrinho).
      p = Promise.resolve([
        { id: 'frete_gratis_sp', nome: 'Frete Grátis - SP (entrega própria)', valor: 0, prazo_dias: 10 },
        { id: 'frete_expresso', nome: 'Frete Expresso - SP (entrega própria)', valor: 70, prazo_dias: 7 },
        { id: 'retirada_fabrica', nome: 'Retirar na fábrica', valor: 0, prazo_dias: 4 }
      ]);
    } else if (porta) {
      p = Promise.resolve({ erro: MSG.porta });
    } else {
      var interior = naFaixa(n, INTERIOR);
      if (grande && !interior) {
        p = Promise.resolve({ erro: MSG.grande });
      } else {
        var proprio = interior ? [{ id: 'entrega_interior', nome: 'Entrega própria - Interior', valor: 300, prazo_dias: 17 }] : [];
        var jad = grande ? Promise.resolve([]) : edge(cep, itens).catch(function () { return interior ? [] : null; });
        p = jad.then(function (qs) {
          if (qs === null) return { erro: MSG.rede };
          var j = qs.filter(ehJadlog)
            .map(function (q) { return opcao(q, DESPACHO_NOVA); })
            .sort(function (a, b) { return a.valor - b.valor; });
          var todas = proprio.concat(j);
          return todas.length ? todas : { erro: MSG.nada };
        });
      }
    }

    p = p.catch(function () { return { erro: MSG.rede }; });
    cache[chave] = p.then(function (r) { if (r && r.erro) delete cache[chave]; return r; });
    return cache[chave];
  }

  /* ---------- calculador (snippet decora-frete com calculador: true) ---------- */

  var CSS = '.dfrete{margin:16px 0 0;font:inherit;color:inherit}' +
    '.dfrete__rot{display:block;font-weight:600;font-size:14px;margin:0 0 8px}' +
    '.dfrete__form{display:flex;gap:8px}' +
    '.dfrete__cep{flex:1;min-width:0;height:44px;padding:0 14px;border:1px solid rgba(0,0,0,.2);border-radius:8px;font:inherit;font-size:15px;background:#fff;color:inherit}' +
    '.dfrete__cep:focus{outline:2px solid currentColor;outline-offset:1px}' +
    '.dfrete__btn{height:44px;padding:0 18px;border:0;border-radius:8px;background:#111;color:#fff;font:inherit;font-weight:600;cursor:pointer}' +
    '.dfrete__btn[disabled]{opacity:.6;cursor:wait}' +
    '.dfrete__ajuda{display:inline-block;margin-top:6px;font-size:12px;color:inherit;opacity:.7}' +
    '.dfrete__res{margin-top:10px;font-size:14px}' +
    '.dfrete__lista{list-style:none;margin:0;padding:0;border:1px solid rgba(0,0,0,.12);border-radius:8px}' +
    '.dfrete__op{display:flex;justify-content:space-between;gap:12px;padding:10px 12px}' +
    '.dfrete__op+.dfrete__op{border-top:1px solid rgba(0,0,0,.08)}' +
    '.dfrete__nome{display:block}.dfrete__prazo{display:block;font-size:12px;opacity:.7}' +
    '.dfrete__valor{font-weight:600;white-space:nowrap}.dfrete__gratis{color:#0a7a3d}' +
    '.dfrete__nota{margin:6px 0 0;font-size:12px;opacity:.7}.dfrete__erro{margin:0;color:#b42318}';

  function css() {
    if (document.getElementById('dfrete-css')) return;
    var s = document.createElement('style'); s.id = 'dfrete-css'; s.textContent = CSS; document.head.appendChild(s);
  }
  function mascara(v) { v = limpa(v); return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; }
  function brl(v) { return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function itensDoProduto(raiz) {
    var mapa = {};
    try { mapa = JSON.parse((raiz.querySelector('[data-dfrete-skus]') || {}).textContent || '{}'); } catch (e) {}
    var form = raiz.closest('form[action*="/cart/add"]') || document.querySelector(raiz.getAttribute('data-form') || 'form[action*="/cart/add"]');
    var idEl = form && form.querySelector('[name="id"]');
    var qEl = form && form.querySelector('[name="quantity"]');
    var id = idEl ? idEl.value : raiz.getAttribute('data-variante');
    var sku = mapa[id] || raiz.getAttribute('data-sku');
    return Promise.resolve(sku ? [{ sku: sku, quantity: qEl ? qEl.value : 1 }] : []);
  }
  function itensDoCarrinho() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { return (c.items || []).map(function (i) { return { sku: i.sku, quantity: i.quantity }; }); });
  }

  function desenha(res, r) {
    if (r && r.erro) { res.innerHTML = '<p class="dfrete__erro">' + esc(r.erro) + '</p>'; return; }
    var obs = '';
    res.innerHTML = '<ul class="dfrete__lista">' + r.map(function (o) {
      if (o.obs) obs = o.obs;
      var prazo = o.prazo_min_dias ? 'de ' + o.prazo_min_dias + ' a ' + o.prazo_dias : 'até ' + o.prazo_dias;
      return '<li class="dfrete__op"><span><span class="dfrete__nome">' + esc(o.nome) + '</span><span class="dfrete__prazo">' +
        prazo + ' dias úteis</span></span><span class="dfrete__valor' + (o.valor ? '' : ' dfrete__gratis') + '">' +
        (o.valor ? brl(o.valor) : 'Grátis') + '</span></li>';
    }).join('') + '</ul>' + (obs ? '<p class="dfrete__nota">' + esc(obs) + ' Valor da Jadlog confirmado no checkout.</p>' : '');
  }

  function montar(raiz, opts) {
    if (!raiz || raiz.__dfrete) return;
    css();
    var origem = raiz.getAttribute('data-origem') || 'pdp';
    var pegaItens = (opts && opts.itens) ? function () { return Promise.resolve(opts.itens()); }
      : origem === 'carrinho' ? itensDoCarrinho : function () { return itensDoProduto(raiz); };
    var inp = raiz.querySelector('.dfrete__cep');
    var btn = raiz.querySelector('.dfrete__btn');
    var res = raiz.querySelector('.dfrete__res');
    var vez = 0, ult = '';

    function calcula() {
      var cep = limpa(inp.value);
      if (cep.length !== 8) { desenha(res, { erro: MSG.cep }); inp.focus(); return; }
      salvarCep(cep);
      var minha = ++vez;
      btn.disabled = true; res.textContent = 'Calculando…';
      pegaItens().then(function (itens) { ult = JSON.stringify(itens); return cotar(cep, itens); }, function () { return { erro: MSG.rede }; })
        .then(function (r) {
          if (minha !== vez) return;
          btn.disabled = false; desenha(res, r);
          raiz.dispatchEvent(new CustomEvent('decora-frete:cotado', { bubbles: true, detail: { cep: cep, resultado: r } }));
        });
    }

    raiz.__dfrete = { calcula: calcula };
    inp.value = mascara(lerCep());
    inp.addEventListener('input', function () { inp.value = mascara(inp.value); });
    // Sem <form> próprio: o calculador pode ficar dentro do formulário do produto, e Enter não pode adicionar ao carrinho.
    btn.addEventListener('click', function (e) { e.preventDefault(); calcula(); });
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calcula(); } });
    if (origem === 'pdp') {
      // A página troca a variante por clique e só muda o valor do campo id (sem evento): confere se o item mudou.
      var t, revisa = function (e) {
        if (raiz.contains(e.target) || !res.innerHTML) return;
        clearTimeout(t); t = setTimeout(function () {
          pegaItens().then(function (itens) { if (JSON.stringify(itens) !== ult) calcula(); });
        }, 300);
      };
      document.addEventListener('click', revisa);
      document.addEventListener('change', revisa);
    }
    if (limpa(inp.value).length === 8) calcula();
  }

  function montarTodos() { [].forEach.call(document.querySelectorAll('[data-decora-frete]'), function (el) { montar(el); }); }
  // Recalcula os calculadores já abertos (ex.: depois de mudar o carrinho).
  function atualizar() { [].forEach.call(document.querySelectorAll('[data-decora-frete]'), function (el) { if (el.__dfrete && limpa(lerCep()).length === 8) el.__dfrete.calcula(); }); }

  window.DecoraFrete = { cotar: cotar, cepSalvo: lerCep, salvarCep: salvarCep, montar: montar, montarTodos: montarTodos, atualizar: atualizar };
  document.addEventListener('decora:carrinho-mudou', atualizar);

  function iniciar() {
    montarTodos();
    if (window.MutationObserver) new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { montarTodos(); return; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
